// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>131</span>&nbsp;&nbsp;I open my mouth and draw in my breath,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;as I long for your commandments.<br> </p> </div></div>";
// Exports
module.exports = code;